import styled, { keyframes } from "styled-components";
import { Variables } from "../../../styles/variables";

const slideIn = keyframes`
    from {
        opacity: 0;
        transform: translateX(16px) translateY(-8px);
    }
    to {
        opacity: 1;
        transform: translateX(0) translateY(0);
    }
`

const shrink = keyframes`
    from { transform: scaleX(1); }
    to { transform: scaleX(0); }
`

export const Overlay = styled.div`
    position: fixed;
    inset: 0;
    z-index: 12000;
    pointer-events: none;
`

export const Container = styled.div<{ $type: 'error' | 'success' | 'warning' | 'info' }>`
    pointer-events: auto;
    position: fixed;
    top: 20px;
    right: 20px;
    left: auto;
    transform: none;
    width: min(380px, calc(100vw - 32px));
    border-radius: 20px;
    overflow: hidden;
    background: #FFF4C4;
    color: ${Variables.gray};
    border: 1px solid rgba(244, 198, 0, 0.7);
    box-shadow: 0 18px 40px rgba(81, 98, 116, 0.18);
    animation: ${slideIn} 0.28s ease;

    .aviso-progress {
        position: absolute;
        top: 0;
        left: 0;
        height: 4px;
        width: 100%;
        transform-origin: left center;
        background: ${Variables.yellow};
        animation: ${shrink} 8s linear forwards;
    }

    .aviso-content {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        padding: 16px 16px 16px;
        color: ${Variables.gray};
    }

    .aviso-text {
        flex: 1;
        margin: 0;
        color: inherit;
        font-family: 'Open Sans', sans-serif;
        font-size: 14px;
        font-weight: 600;
        line-height: 1.45;
        letter-spacing: 0.1px;
        white-space: pre-line;
    }

    .aviso-close {
        flex-shrink: 0;
        border: 0;
        background: transparent;
        color: inherit;
        cursor: pointer;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        color: inherit;
        opacity: 0.85;
        transition: opacity 0.15s ease, background 0.15s ease;

        &:hover {
            opacity: 1;
            background: rgba(81, 98, 116, 0.08);
        }

        svg {
            width: 14px;
            height: 14px;
        }
    }

    @media (max-width: 575.98px) {
        top: 12px;
        right: 12px;
        width: calc(100vw - 24px);
    }
`
